module.exports = "<dw-base-iframe [item]=\"item\" [itemObserve]=\"itemRxjsBehavior\" *ngIf=\"!usingTab\"></dw-base-iframe>\n"